/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { deviceIntegrationsListProviders } from "../funcs/deviceIntegrationsListProviders.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDeviceIntegrationProvidersResult } from "../models/components/listdeviceintegrationprovidersresult.js";
import {
  ListDeviceIntegrationProvidersRequest,
  ListDeviceIntegrationProvidersSecurity,
} from "../models/operations/listdeviceintegrationproviders.js";
import { unwrapAsync } from "../types/fp.js";
export type DeviceIntegrationProvidersQueryData =
  ListDeviceIntegrationProvidersResult;

export function prefetchDeviceIntegrationProviders(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListDeviceIntegrationProvidersRequest | undefined,
  security?: ListDeviceIntegrationProvidersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDeviceIntegrationProvidersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDeviceIntegrationProvidersQuery(
  client$: GramCore,
  request?: ListDeviceIntegrationProvidersRequest | undefined,
  security?: ListDeviceIntegrationProvidersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DeviceIntegrationProvidersQueryData>;
} {
  return {
    queryKey: queryKeyDeviceIntegrationProviders({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function deviceIntegrationProvidersQueryFn(
      ctx,
    ): Promise<DeviceIntegrationProvidersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(deviceIntegrationsListProviders(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDeviceIntegrationProviders(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "deviceIntegrations", "listProviders", parameters];
}
